import { render } from "./PageLayoutWithTopBar.vue?vue&type=template&id=db837904&scoped=true"
import script from "./PageLayoutWithTopBar.vue?vue&type=script&lang=js"
export * from "./PageLayoutWithTopBar.vue?vue&type=script&lang=js"

import "./PageLayoutWithTopBar.vue?vue&type=style&index=0&id=db837904&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db837904"]])

export default __exports__